/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ResponseResourcesUrls } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Resources<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Resources
   * @name GetResourcesUrls
   * @request GET:/api/v1/resources
   * @secure
   * @response `200` `ResponseResourcesUrls` OK
   */
  getResourcesUrls = (params: RequestParams = {}) =>
    this.http.request<ResponseResourcesUrls, any>({
      path: `/api/v1/resources`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
